/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export type FetchAiDraftPreviewContentResponse = {
	content: string;
	topicId: string;
};

const APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';

const getAiDraftPreviewContentUrl = (
	projectId: number,
	activationId: string,
	topicId: string,
	contentFormat: string,
) =>
	`${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topic/${topicId}/draft-article?contentFormat=${contentFormat}`;

export const fetchAiDraftPreviewContent = (
	projectId: number,
	activationId: string,
	topicId: string,
): Promise<FetchAiDraftPreviewContentResponse> => {
	const contentFormat = 'text/adf';
	const url = getAiDraftPreviewContentUrl(projectId, activationId, topicId, contentFormat);
	return performGetRequest(url);
};
